module.exports = __webpack_public_path__ + "img/refresh.409ca49d.svg";